<template>
  <div class="bg_white">
    <van-nav-bar title="人脸识别" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon name="service-o" size="20" />
      </template>
    </van-nav-bar>

    <van-cell-group>
      <template #title>
        <span class="title">点击实时人脸识别：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file1" multipart :max-count="1" upload-text="开始识别" :after-read="afterRead" capture="camera">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>

    <div class="pd16 m40">
      <van-button class="btn_bg" round block type="default" size="large" @click="onSubmit">提交</van-button>
    </div>

  </div>
</template>

<script>
import { upload } from "../../api/upload"
import {compareFace} from "../../api/onlineexam"
export default {
  data() {
    return {
      param: {
        upPhoto: '',
        id:null
      },
      file1: [],
      file2: [],
      file3: [],
      file4: [],
      file5: [],
      file6: [],
    }

  },
  created(){
    this.param.id=this.common.getQueryString("id")
    console.log(this.param.id)
  },
  methods: {
    onSubmit(){
      let that=this
      compareFace(this.param).then(res=>{
        console.log(res)
        if(res.success){
          that.$toast({
            type:'success',
            message:"认证通过",
            onClose:()=>{
              that.$router.back()
            }

          })
        }else{
          this.$dialog.alert({
                    message: res.message,
                    theme: 'round-button',
                    confirmButtonText:'确定'
         }).then(()=>{
          console.log(res.message)
            that.$router.push("/upload")
         })
        }
      })
    },
    //2寸免冠照
    afterRead(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.upPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.upPhoto)
        }
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },
  }

};
</script>

<style lang="less"></style>

